import { H5, LI, UL } from "../../../../AbstractElements";
import { Badge } from "reactstrap";
import { BALANCE_LIST_DATA } from "../../../../Data/Widgets/GeneralWidgets";

const BalanceList = () => {
  return (
    <UL className="simple-list d-flex flex-row">
      {BALANCE_LIST_DATA.map((item, index) => (
        <LI className="border-0 bg-none" key={index}>
          <div className={`balance-item ${item.color}`}>
            <div className="balance-icon-wrap">
              <div className="balance-icon">{item.icon}</div>
            </div>
            <div>
              <span className="f-12 f-light">{item.spanText}</span>
              <H5>{item.title}</H5>
              <Badge pill color={`light-${item.color}`}>{item.badge}</Badge>
            </div>
          </div>
        </LI>
      ))}
    </UL>
  );
};

export default BalanceList;
